'use client'

const steps = [
  {
    n: 'i',
    h: <>Speak <em>Naturally</em></>,
    p: 'Tell AVA what you need in your own words — like talking to a friend.',
    q: 'Schedule a dentist appointment for next Tuesday',
    italic: true,
  },
  {
    n: 'ii',
    h: <>AVA <em>Understands</em></>,
    p: 'AI processes your intent and context instantly with smart learning.',
    q: 'Checks calendar · creates task · sets reminder',
    italic: false,
  },
  {
    n: 'iii',
    h: <>It&rsquo;s <em>Done</em></>,
    p: 'Your request is handled automatically across all your devices.',
    q: 'Appointment added · conflicts checked · synced everywhere',
    italic: false,
  },
]

export default function HowItWorks() {
  return (
    <div className="steps">
      {steps.map((s, i) => (
        <div className="step" key={i}>
          <div className="n">{s.n}</div>
          <div>
            <h3 className="h">{s.h}</h3>
            <p className="p">{s.p}</p>
          </div>
          <p className={'quote' + (s.italic ? '' : ' mono')}>
            {s.italic ? <em>&ldquo;{s.q}&rdquo;</em> : s.q}
          </p>
        </div>
      ))}
    </div>
  )
}
